<template>
	<v-btn
		color="primary"
		depressed small
		:disabled="disableAllFields"
		@click="toggleState">
		<v-icon id="three-state-button-icon">{{ icon }}</v-icon>
	</v-btn>
</template>

<script>
	export default {
		name: "EgrantyThreeStateSwitch",

		data() {
			return {
				state: "ALL",
				stateValue: null,
			};
		},

		methods: {
			toggleState(e) {
				switch (this.state) {
					case "ALL":
						this.stateValue = "PASSED";
						break;
					case "PASSED":
						this.stateValue = "NOT_PASSED";
						break;
					case "NOT_PASSED":
						this.stateValue = "UNKNOWN";
						break;
					case "UNKNOWN":
						this.stateValue = "ALL";
						break;
				}

				this.$emit("input", this.stateValue);
				this.$emit("change", this.stateValue);
				this.$emit("click", e);
			},
		},

		computed: {
			icon() {
				switch (this.state) {
					case "ALL":
						return "";
					case "PASSED":
						return "done";
					case "NOT_PASSED":
						return "clear";
					case "UNKNOWN":
						return "help_outline";
				}
				return "";
			},
		},

		watch: {
			value: {
				immediate: true,
				handler(newVal) {
					this.stateValue = newVal;
					this.state = newVal;
				},
			},
		},

		props: {
			value: {type: String},
			disableAllFields: {type: Boolean, default: false}
		},
	};
</script>

<style scoped>
	button {
		display: inline-flex;
		width: 32px;
		min-width: inherit;
		height: 32px;
		padding: 4px;
		min-height: inherit;
	}

	#three-state-button-icon {
		-webkit-transform: none;
		transform: none;
	}
</style>
